import MuiPaper, { PaperProps as MuiPaperProps } from '@mui/material/Paper';
import React, { forwardRef, Ref } from 'react';
import useAnimations from '../../hooks/use-animations';

export interface PaperProps extends MuiPaperProps {
	/** Enables a pulsing animation - useful for content in a pending state.
	 * @default false
	 */
	pulse?: boolean;
	component?: React.ElementType;
}

/** An extension of Mui's Paper component.
 *
 * __Paper__ can be used as a basic surface element. It mirrors the characteristics of a sheet of paper, with its squareness and elevation easily customziable.
 * We've also added a __pulse__ animation that can be turned on for content that is in a pending state.
 */
export const Paper = forwardRef((props: PaperProps, ref: Ref<HTMLDivElement>) => {
	const { pulse, className, component, ...rest } = props;
	const animations = useAnimations();
	const styles = pulse ? `${className} ${animations.pulse}` : className;
	return <MuiPaper ref={ref} component={component} {...rest} className={styles} />;
});
